export default __webpack_public_path__ + "static/media/happy_to_help_slide_4.670e64f9.png";